

import React, { memo, useContext, useMemo } from 'react';
import {
  hasDataTableRowSpacer,
  isDataTableFlatRowExpanded, isDataTableTreeRowNodeLastInLevel,
  isDataTableTreeRowNodeChildrenVisible,
  isDataTableTreeRowNodeLastVisibleInBranch } from
'../../utils/dataTableRow';
import DataTableBodyRow from './DataTableBodyRow';
import DataTableBodyCell from './DataTableBodyCell';

import { isDataTableTreeColumn } from '../../utils/factories/dataTableColumnFactory';
import { sortDataTableFlatRowsNodes } from '../../utils/dataTableSort';
import { DataTableContext } from '../../context/dataTableContext';






const DataTableBodyTree = (props) => {
  const { treeRowsNodes, isParentLastTreeRowNodeInLevel } = props;

  const {
    sort,
    isExternalSortOption,
    flatRowsNodes,
    columns
  } = useContext(DataTableContext);

  const treeRowsNodesSorted = useMemo(() =>
  isExternalSortOption ?
  treeRowsNodes :
  sortDataTableFlatRowsNodes(
    treeRowsNodes,
    columns,
    sort
  ),
  [treeRowsNodes, columns, sort, isExternalSortOption]);

  return (
    <>
      {
      treeRowsNodesSorted.map((treeRowNode, rowIndex) =>
      <React.Fragment key={treeRowNode.id}>
            {
        hasDataTableRowSpacer(rowIndex, treeRowNode) &&

        <DataTableBodyRow
          rowIndex={rowIndex}
          treeRowNode={treeRowNode}
          isSpacer />}




            <DataTableBodyRow
          rowIndex={rowIndex}
          treeRowNode={treeRowNode}
          isLastVisibleInBranch={isDataTableTreeRowNodeLastVisibleInBranch(
            treeRowNode,
            treeRowsNodesSorted,
            flatRowsNodes,
            isParentLastTreeRowNodeInLevel
          )}
          isExpanded={isDataTableFlatRowExpanded(
            treeRowNode.id,
            flatRowsNodes
          )}>

              {columns.map((column, index) =>
          <DataTableBodyCell
            key={column.field}
            column={column}
            treeRowNode={treeRowNode}
            isTree={isDataTableTreeColumn(index)}
            isExpanded={isDataTableFlatRowExpanded(
              treeRowNode.id,
              flatRowsNodes
            )} />

          )}
            </DataTableBodyRow>

            {isDataTableTreeRowNodeChildrenVisible(
          treeRowNode,
          flatRowsNodes
        ) &&

        <DataTableBodyTree
          treeRowsNodes={treeRowNode.children}
          treeRowNodeParent={treeRowNode}
          isParentLastTreeRowNodeInLevel={isDataTableTreeRowNodeLastInLevel(
            treeRowNode,
            treeRowsNodesSorted
          )} />}



          </React.Fragment>
      )}

    </>);

};

export default memo(DataTableBodyTree);